import { render } from "./ChatView.vue?vue&type=template&id=6bb45a42"
const script = {}
script.render = render

export default script